import { ApiError } from "models/meta/api";
import { Action } from "models/meta/action";

export type ErrorHandler = (error: ApiError) => { predicate: () => boolean, handler: () => Action[] }[]

export const INVALID_CSR_STRUCTURE_TOAST_ID = 'invalidCsrStructure';
export const INVALID_CSR_VALUES_TOAST_ID = 'invalidCsrValues';
export const UNATHORIZED_TOAST_ID = 'genericUnauthorizedMessage';
